import { Footer as FooterBase } from "@ubnt/store.core/lib/components/Footer";
import styled from "styled-components";

export const StyledFooter = styled(FooterBase)`
z-index: 1000;
`